import { Outlet } from "react-router-dom"

export const LayoutActus = () => {
    return (
        <main>
            <Outlet />
        </main>
    )
}